module.exports = __webpack_public_path__ + "media/level-up.0258afa1.mp3";